const PUBLIC_KEYS = [
  'RAZZLE_ALGOLIA_WELLO_API_KEY',
  'RAZZLE_ALGOLIA_WELLO_APP_ID',
  'RAZZLE_BACKEND_URL',
  'RAZZLE_CANONICAL_HOST',
  'RAZZLE_ENVIRONMENT',
  'RAZZLE_GTM_ID',
  'RAZZLE_MAPBOX_GEOCODER_API_KEY',
  'RAZZLE_SENTRY_DSN',
  'RAZZLE_VERSION_ID',
  'RAZZLE_WEBSOCKET_URL',
];

const isBrowser = typeof window !== 'undefined';

export default function env(key) {
  if (isBrowser) {
    return (window.__ENV__ || {})[key];
  }
  return process.env[key];
}

export function publicEnvScript() {
  const values = PUBLIC_KEYS.reduce((acc, key) => ({ ...acc, [key]: process.env[key] }), {});
  return `<script>window.__ENV__ = ${JSON.stringify(values).replace(/</g, '\\u003c')}</script>`;
}
